// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"231f292f","455":"676f42a6"}[chunkId] + ".chunk.js";
};